<template>
  <div class="pg-monaco-editor-dialog">
    <Button type="text" class="pg-monaco-editor-dialog-btn" @click="visible = true">编辑</Button>
    <Dialog
      top=""
      append-to-body
      :close-on-click-modal="false"
      custom-class="pg-dialog pg-monaco-editor-dialog-dialog"
      :visible.sync="visible"
      @open="open"
      :title="title"
      width="80%"
    >
      <monacoEditor
        class="source-code-dialog__editor"
        :language="language"
        :valueType="valueType"
        v-model="data"
      />
      <template #footer>
        <ElButton class="pg-dialog__btn" round @click="visible = false">取消</ElButton>
        <ElButton class="pg-dialog__btn" type="primary" round @click="sure">确定</ElButton>
      </template>
    </Dialog>
  </div>
</template>
<script setup>
import { Dialog, Button } from 'element-ui'
import { ref } from 'vue'
import monacoEditor from './monaco-editor.vue'
import { clone } from '../../../utils/index'

const props = defineProps({
  value: [String, Object, Array],
  language: {
    type: String,
    default: 'json',
  },
  valueType: {
    type: String,
    default: 'object',
  },
  title: {
    type: String,
    default: '编辑',
  },
})
const emit = defineEmits(['input'])

const visible = ref(false)
const data = ref(null)
const open = () => {
  if (props.valueType === 'object' && props.value) {
    data.value = clone(props.value)
  } else {
    data.value = props.value
  }
}
const sure = () => {
  visible.value = false
  emit('input', data.value)
}
</script>
<style lang="scss">
.pg-monaco-editor-dialog-dialog {
  .pg-monaco-editor-dialog-btn {
    padding: 0;
  }
}
.pg-monaco-editor-dialog-dialog {
  display: flex;
  flex-direction: column;
  height: calc(100% - 200px);
  .el-dialog__body {
    flex: 1;
  }
}
</style>
